import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import useChangeCheck from "./useChangeCheck";
import ChangeCheckContext from "../support/ChangeCheckContext";
import "../_static/SelectInput.css"

function SelectInput(props) {

    const { onChange, getStyle } = useChangeCheck(props.onChange);
    const {disable} = React.useContext(ChangeCheckContext)

    function handleChange(event) {
        const selected = event.target.value
        onChange({target: {name: props.name, value: selected}})
    }

    return (
        <>
            {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
            <InputGroup className={props.skipMb ? "" : "mb-3"}>
                <Form.Select disabled={disable} value={props.value} onChange={handleChange} style={getStyle()}>
                    {props.options && props.options.map((option, ndx) => (
                        <option key={ndx} value={option}>{option}</option>
                    ))}
                </Form.Select>
            </InputGroup>
        </>
    )
}

export default SelectInput
